document.addEventListener("click", function (event) {
  const button = event.target.closest("[data-cs-menu-button]");
  if (!button) return;

  const header = button.closest(".cs-global-header");
  const menu = header ? header.querySelector("[data-cs-mobile-nav]") : null;
  if (!menu) return;

  const isOpen = button.getAttribute("aria-expanded") === "true";
  button.setAttribute("aria-expanded", String(!isOpen));
  menu.hidden = isOpen;
});
